import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../../../Icon';
import { ImageFromCdn } from '../../../ImageFromCdn';
export var Image = function (_a) {
  var src = _a.src;
  if (!src) return null;
  if (/^icon\|/i.test(src)) {
    var sprite = src.replace(/^icon\|/, 'icon-');
    return _jsx(Icon, {
      size: 16,
      type: sprite
    });
  }
  return _jsx(ImageFromCdn, {
    src: src
  });
};